import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from './../../services/authentication.service';
import { UserModel } from 'src/app/model/UserModel';
import { AccountService } from './../../services/account.service';


@Component({
  selector: 'app-nin-content',
  templateUrl: './nin-content.component.html',
  styleUrls: ['./nin-content.component.css']
})
export class NinContentComponent implements OnInit {

  currentUser: UserModel;
  model:{
    nin:string,
    customerid:number
  }={nin:"",customerid:0 };





  constructor(private toastr: ToastrService,
   private authenticationService: AuthenticationService, private router: Router,
  private accountService: AccountService) { }

  ngOnInit() {
    this.currentUser = this.authenticationService.getCurrentUser();

  }





OnSubmit()
{

  let icustomer=parseInt(this.currentUser.i_Customer);
  this.model.customerid=icustomer;
   const result=this.accountService.UpdateNin(this.model).subscribe((data)=>{
  if(data.Status===1){
 this.model={nin:"",customerid:icustomer};
 this.toastr.success("NIN Uploaded Successfully");
               this.router.navigate(['/dashboard']);  
   
  }
  else{
this.toastr.error(data.Message);
  }
});
   
  }

GoHome(){
 

               this.router.navigate(['/dashboard']);  

}
}
